module.exports = __webpack_public_path__ + "img/叶坪中华苏维埃共和国临时中央政府旧址.42f16b24.png";